import { useEffect, useState } from "react";
import { createBlog, deleteBlog, getBlogs } from "../api/api";

import '../App.css';

function Dashboard() {
  const [blogs, setBlogs] = useState([]);
  const [form, setForm] = useState({});
  const token = localStorage.getItem("token");

  useEffect(() => {
    loadBlogs();
  }, []);

  const loadBlogs = async () => {
    const data = await getBlogs();
    setBlogs(data);
  };

  const handleCreate = async () => {
    await createBlog(form, token);
    loadBlogs();
  };

  const handleDelete = async (id) => {
    await deleteBlog(id, token);
    loadBlogs();
  };

  return (
  <div className="container">
    <h2>Dashboard</h2>

    {/* Create Blog */}
    <div className="create-blog">
      <input
        placeholder="Title"
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      <textarea
        placeholder="Content"
        onChange={(e) => setForm({ ...form, content: e.target.value })}
      />

      <button onClick={handleCreate}>Create Blog</button>
    </div>

    {/* Blog List */}
    <div className="blog-list">
      {blogs.map((blog) => (
        <div className="blog-item" key={blog.id}>
          <h3>{blog.title}</h3>
          <p>{blog.content?.substring(0, 80)}...</p>

          <button onClick={() => handleDelete(blog.id)}>
            Delete
          </button>
        </div>
      ))}
    </div>
  </div>
);
}

export default Dashboard;